import Bugsnag from "@bugsnag/js";
import {createRootRoute} from '@tanstack/react-router'
import {TanStackRouterDevtools} from '@tanstack/react-router-devtools'
import React from "react";
import AppContainer from "../AppContainer.tsx";
import {config} from "../config/config.ts";
import Public404Page from "../landing/Public404Page.tsx";


export const Route = createRootRoute({
    component: () => {
        const ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React)

        return <>
            {ErrorBoundary
                ? <ErrorBoundary FallbackComponent={(e) =>
                    (config.isTestMode
                        ? <div className="my-4 mt-8 w-3/4 mx-auto"><h3 className="mb-2">An error has occurred:</h3>
                            <pre className="text-xs">
                                        {e.error?.message}<br />
                                {e?.error.stack}
                                    </pre>
                        </div>
                        : <div className="my-4 mt-8 w-3/4 mx-auto"><h3 className="mb-2">
                            An error has occurred. We have been notified and will look into it.</h3>
                            <a href="/" className="underline">Go to the front page</a>
                        </div>)
                }>
                    <AppContainer />
                </ErrorBoundary>
                : <AppContainer />
            }
            <TanStackRouterDevtools />
        </>
    },

    notFoundComponent: () => (
        <Public404Page />
    ),
})
